import { render } from "./SegmentsTab.vue?vue&type=template&id=5f8e5d21&scoped=true"
import script from "./SegmentsTab.vue?vue&type=script&lang=js"
export * from "./SegmentsTab.vue?vue&type=script&lang=js"

import "./SegmentsTab.vue?vue&type=style&index=0&id=5f8e5d21&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8e5d21"]])

export default __exports__